import React from "react";
import "./Home3.css";
import Imag1 from "../../assets/images/OIP (16).jpeg";
import Imag2 from "../../assets/images/OIP (17).jpeg";
import Imag3 from "../../assets/images/abcde.png";

const Component3 = () => {
  return (
    <div className="section-two ">
      <div className="main-two bg-info-subtle">
        <h1 className="text-center ">HOW DO WE WORK? </h1>
        <h4 className="text-center ">
          Research, plan, execute tasks, communicate effectively, adapt, and
          continuously improve processes?
        </h4>
      </div>
      <div className="section-two-a d-flex pb-5">
        <div className="para-1 text-center ">
          <img className="border rounded-circle" src={Imag1} alt="loading" />
          <h4 className="">ASSESSMENT</h4>
          <p className="">
            We identify objectives, design tasks, administer assessments,
            collect data, analyze results, provide feedback, and adjust
            instruction based on findings. In Bangladesh, we have successfully
            delivered these services to thousands of our valued clients.
          </p>
        </div>
        <div className="para-2 text-center ">
          <img className="border rounded-circle" src={Imag2} alt="loading" />
          <h4 className="">PROCESSING AND COMMUNICATION</h4>
          <p className="">
            Processing and communication are vital for successful interactions
            across personal, academic, and professional contexts. Together, they
            ensure that information is effectively shared, comprehended, and
            applied.
          </p>
        </div>
        <div className="para-3 text-center ">
          <img className="border rounded-circle" src={Imag3} alt="loading" />
          <h4 className="">RESULT</h4>
          <p className="">
            Visa processing usually takes approximately 3 to 5 weeks. Once the
            processing is complete, the consulate will inform you of the
            decision, and visa delivery may require up to two additional
            business days.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Component3;
